import React from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    IconButton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {colors} from '../../../constants'
import {LeftChevronIcon} from '../../icons'

const LeftButton = ({
    onClick,
    width = '7px',
    height = '14px',
    active = true
}) => {
    const inactiveProps = !active && {
        filter: 'grayscale(100%)',
        opacity: 0.3,
        pointerEvents: 'none'
    }

    return (
        <Box>
            <IconButton
                minWidth="7px"
                data-testid="product-scroller-nav-left"
                height="fit-content"
                color={colors.black}
                icon={<LeftChevronIcon width={width} height={height} />}
                borderRadius="full"
                colorScheme="whiteAlpha"
                onClick={onClick}
                {...inactiveProps}
            />
        </Box>
    )
}

LeftButton.displayName = 'LeftButton'

LeftButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    active: PropTypes.bool
}

export default LeftButton
